var _path, _path2, _ellipse, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 48,
    viewBox: "0 0 29 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00503244 20.6109C-0.15241 15.8177 3.42357 12.2286 5.23123 11.0332C4.98632 16.3163 9.96908 19.9841 12.4911 21.1576C19.7684 24.5339 22.6665 30.8884 23.2059 33.6436C27.5793 30.1974 27.1565 24.2919 26.3985 21.7699C32.7486 36.8668 20.0206 44.9707 12.8628 47.1355C14.1311 42.6309 9.01422 37.2517 7.00246 35.2399C5.39306 33.6305 3.70784 31.2747 3.06641 30.298C2.11155 29.0661 0.162474 25.4042 0.00503244 20.6109Z",
    fill: "#005B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2843 11.0771C2.31866 11.1821 2.11166 4.31292 3.50385 0.865234C5.18761 7.16292 14.2843 4.40768 16.9739 3.99221C19.1256 3.65983 21.2525 4.37852 22.047 4.77942C23.3765 4.39456 24.3941 2.94259 24.7367 2.26472C25.6638 4.38144 25.123 6.16433 24.7367 6.79118C29.0576 11.1471 25.7644 17.6736 23.5777 20.3924C22.2307 12.9577 16.8208 11.0844 14.2843 11.0771Z",
    fill: "#005B9B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.3834,
    cy: 12.6738,
    rx: 2.7115,
    ry: 2.73337,
    fill: "#005B9B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8854,
    cy: 13.8975,
    rx: 0.984013,
    ry: 1.00588,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.3e8495b133ed7eb7da24fac14f08ca77.svg";
export { ForwardRef as ReactComponent };